import moment from "moment";
import Highcharts from "highcharts";
import { theme } from "@/options/theme";

var group_map_tile = [
  {
    group: 1427,
    sn: "FFFF-F921",
    sw: [110.20905673461088, 39.31241231880758],
    ne: [110.21853672703288, 39.31621632573653]
  },
  {
    group: 1425,
    sn: "FFFF-F919",
    sw: [110.53312020449442, 39.04960739946418],
    ne: [110.54260745487997, 39.053413486067626]
  },
  {
    group: 1428,
    sn: "FFFF-F922",
    sw: [110.2472456483533, 39.265612602222944],
    ne: [110.25672693213885, 39.269410701084134]
    // sw: [110.24854998061922, 39.26560367313253],
    // ne: [110.25556270467847, 39.26759457933027]
  },
  {
    group: 1426,
    sn: "FFFF-F920",
    sw: [110.13799356325498, 39.420962051052186],
    ne: [110.14746895659081, 39.42475897109394]
  },
  {
    group: 1424,
    sn: "FFFF-F918",
    // sw: [110.1762986661899, 38.74699337061906],
    // ne: [110.18578430541436, 38.75082020430984]
    sw: [110.17753189581391, 38.746996720253286],
    ne: [110.18458107105933, 38.75082986644129]
  }
];

Highcharts.setOptions({
  lang: {
    resetZoom: "返回",
    loading: "加载中..."
  },
  credits: {
    enabled: false
  },
  global: {
    useUTC: false //关闭UTC
  }
});
Highcharts.setOptions(theme);
var option = {
  chart: {
    zoomType: "xy",
    style: {
      spacingTop: "0px"
    }
  },
  loading: {
    labelStyle: {
      color: "white"
    },
    style: {
      backgroundColor: "rgb(7, 17, 33)"
    }
  },
  title: { text: "" },
  subtitle: { text: " " },
  yAxis: {
    title: {
      text: "",
      style: {
        fontSize: "1.71vh"
      }
    },
    min: 0,
    labels: {
      style: {
        fontSize: "1.71vh"
      },
      x: -10,
      y: 10
    },
    showLastLabel: true
  },
  xAxis: {
    type: "datetime",
    tickPixelInterval: 150,
    dateTimeLabelFormats: {
      millisecond: "%H:%M:%S.%L",
      second: "%H:%M:%S",
      minute: "%H:%M",
      hour: "%H:%M",
      day: "%m-%d",
      week: "%m-%d",
      month: "%Y-%m",
      year: "%Y"
    },
    plotLines: [],
    // tickPositioner:function(){
    //   if(this.chart.series[0].userOptions.timetype=='week'|| this.chart.series[0].userOptions.timetype == 'period'){
    //     return this.chart.series[0].processedXData
    //   }
    // },

    labels: {
      style: {
        fontSize: "1.71vh"
      },
      step: 1,
      formatter: function() {
        let timetype = this.chart.series[0].userOptions.timetype;
        let str = "";
        switch (timetype) {
          case "real":
            str = moment(this.value).format("HH:mm");
            break;
          case "min":
            str = moment(this.value).format("HH:mm");
            break;
          case "day":
            str = moment(this.value).format("M月D日");
            break;
          case "hour":
            str = moment(this.value).format("DD日H时");
            break;

          case "period":
            if (moment(this.value).format("D") == "1") {
              str = moment(this.value).format("M") + "月上旬";
            } else if (moment(this.value).format("D") == "11") {
              str = moment(this.value).format("M") + "月中旬";
            } else {
              str = moment(this.value).format("M") + "月下旬";
            }
            break;
          case "month":
            if (
              moment(this.value).format("YYYY") !=
              moment(this.value)
                .add(1, "month")
                .format("YYYY")
            ) {
              str =
                moment(this.value).format("YYYY") +
                "年" +
                moment(this.value).format("M") +
                "月";
            } else {
              str = moment(this.value).format("M") + "月";
            }

            break;
          case "week":
            if (
              moment(this.value).format("M") !=
              moment(this.value)
                .add(6, "days")
                .format("M")
            ) {
              str =
                moment(this.value).format("M月D日") +
                "~" +
                moment(this.value)
                  .add(6, "days")
                  .format("D日");
            } else {
              str =
                moment(this.value).format("D日") +
                "~" +
                moment(this.value)
                  .add(6, "days")
                  .format("D日");
            }
            str =
              moment(this.value).format("M月D日") +
              "~" +
              moment(this.value)
                .add(6, "days")
                .format("D日");
            // str = this.value
            break;
        }
        return str;
      }
    }
  },
  tooltip: {
    // valueDecimals: 1,
    shared: true,
    crosshairs: true,
    useHTML: true,
    style: {
      // padding: 10,
      fontSize: "1.71vh"
    },
    formatter: function() {
      let timetype = this.points[0].point.series.userOptions.timetype;
      let data_type = this.points[0].point.series.userOptions.id;
      let p = this.points[0];
      let str = "";
      switch (timetype) {
        case "real":
          str = moment(p.x).format("YYYY-MM-DD HH:mm");
          break;
        case "min":
          str = moment(p.x).format("YYYY-MM-DD HH:mm");
          break;
        case "day":
          str = moment(p.x).format("YYYY-MM-DD");
          break;
        case "hour":
          str = moment(p.x).format("YYYY-MM-DD HH时");
          break;
        case "period":
          if (moment(p.x).format("DD") == "01") {
            str =
              moment(p.x).format("YYYY-MM-01") +
              "~" +
              moment(p.x).format("MM-11");
          } else if (moment(p.x).format("DD") == "11") {
            str =
              moment(p.x).format("YYYY-MM-11") +
              "~" +
              moment(p.x).format("MM-21");
          } else {
            str =
              moment(p.x).format("YYYY-MM-21") +
              "~" +
              moment(p.x)
                .endOf("month")
                .format("MM-DD");
          }
          break;
        case "month":
          str =
            moment(p.x).format("YYYY-MM-01") +
            "~" +
            moment(p.x)
              .endOf("month")
              .format("MM-DD");
          break;
        case "week":
          str =
            moment(p.x).format("YYYY-MM-DD") +
            "~" +
            moment(p.x)
              .add(6, "days")
              .format("MM-DD");
          break;
      }
      str += "<br>";
      for (let item of this.points) {
        str += `<span style="color:${item.color}">${
          item.series.name
        }</span> : <span>${colorIntensity.sensortypeRound(data_type, item.y)} ${
          colorIntensity.getSensorDataInfo(data_type).unit
          // _page_config.sensortypes.find(x => x.value == data_type).unit
        }</span><br>`;
      }
      return str;
    },
    dateTimeLabelFormats: {
      millisecond: "%H:%M:%S.%L",
      second: "%H:%M:%S",
      minute: "%H:%M",
      hour: "%H:%M",
      day: "%m-%d",
      week: "%m-%d",
      month: "%Y-%m",
      year: "%Y"
    }
  },
  legend: {
    enabled: true
  },
  plotOptions: {
    series: {
      connectNulls: true,
      lineWidth: 2,
      marker: {
        radius: 4
      }
      // cursor: "pointer"
    }
  },
  series: []
};

var optionDetail = {
  chart: {
    zoomType: "xy",
    style: {
      spacingTop: "0px"
    }
  },
  loading: {
    labelStyle: {
      color: "white"
    },
    style: {
      backgroundColor: "rgb(7, 17, 33)"
    }
  },
  title: { text: "" },
  subtitle: { text: " " },
  yAxis: {
    title: {
      text: "",
      style: {
        fontSize: "1.71vh"
      }
    },
    min: 0,
    labels: {
      style: {
        fontSize: "1.71vh"
      },
      x: -10,
      y: 10
    },
    showLastLabel: true
  },
  xAxis: {
    type: "datetime",
    // tickPixelInterval: 200,
    dateTimeLabelFormats: {
      millisecond: "%H:%M:%S.%L",
      second: "%H:%M:%S",
      minute: "%H:%M",
      hour: "%H:%M",
      day: "%m-%d",
      week: "%m-%d",
      month: "%Y-%m",
      year: "%Y"
    },
    plotLines: [],
    // tickPositioner:function(){
    //   if(this.chart.series[0].userOptions.timetype=='week'|| this.chart.series[0].userOptions.timetype == 'period'){
    //     return this.chart.series[0].processedXData
    //   }
    // },

    labels: {
      style: {
        fontSize: "1.71vh"
      },
      step: 1,
      formatter: function() {
        let timetype = this.chart.series[0].userOptions.timetype;
        let str = "";
        switch (timetype) {
          case "min":
            str = moment(this.value).format("HH:mm");
            break;
          case "day":
            str = moment(this.value).format("M月D日");
            break;
          case "hour":
            str = moment(this.value).format("DD日H时");
            break;

          case "period":
            if (moment(this.value).format("D") == "1") {
              str = moment(this.value).format("M") + "月上旬";
            } else if (moment(this.value).format("D") == "11") {
              str = moment(this.value).format("M") + "月中旬";
            } else {
              str = moment(this.value).format("M") + "月下旬";
            }
            break;
          case "month":
            if (
              moment(this.value).format("YYYY") !=
              moment(this.value)
                .add(1, "month")
                .format("YYYY")
            ) {
              str =
                moment(this.value).format("YYYY") +
                "年" +
                moment(this.value).format("M") +
                "月";
            } else {
              str = moment(this.value).format("M") + "月";
            }

            break;
          case "week":
            if (
              moment(this.value).format("M") !=
              moment(this.value)
                .add(6, "days")
                .format("M")
            ) {
              str =
                moment(this.value).format("M月D日") +
                "~" +
                moment(this.value)
                  .add(6, "days")
                  .format("D日");
            } else {
              str =
                moment(this.value).format("D日") +
                "~" +
                moment(this.value)
                  .add(6, "days")
                  .format("D日");
            }
            break;
        }
        return str;
      }
    }
  },
  tooltip: {
    valueDecimals: 1,
    shared: true,
    crosshairs: true,
    useHTML: true,
    style: {
      // padding: 10,
      fontSize: "1.71vh"
    },
    formatter: function() {
      let timetype = this.points[0].point.series.userOptions.timetype;
      let p = this.points[0];
      let str = "";
      switch (timetype) {
        case "min":
          str = moment(p.x).format("YYYY-MM-DD HH:mm");
          break;
        case "day":
          str = moment(p.x).format("YYYY-MM-DD");
          break;
        case "hour":
          str = moment(p.x).format("YYYY-MM-DD HH时");
          break;
        case "period":
          if (moment(p.x).format("DD") == "01") {
            str =
              moment(p.x).format("YYYY-MM-01") +
              "~" +
              moment(p.x).format("MM-11");
          } else if (moment(p.x).format("DD") == "11") {
            str =
              moment(p.x).format("YYYY-MM-11") +
              "~" +
              moment(p.x).format("MM-21");
          } else {
            str =
              moment(p.x).format("YYYY-MM-21") +
              "~" +
              moment(p.x)
                .endOf("month")
                .format("MM-DD");
          }
          break;
        case "month":
          str =
            moment(p.x).format("YYYY-MM-01") +
            "~" +
            moment(p.x)
              .endOf("month")
              .format("MM-DD");
          break;
        case "week":
          str =
            moment(p.x).format("YYYY-MM-DD") +
            "~" +
            moment(p.x)
              .add(6, "days")
              .format("MM-DD");
          break;
      }
      str += "<br>";
      for (let item of this.points) {
        str += `<span style="color:${item.color}">${
          item.series.name
        }</span> : <span>${Math.round(item.y)} ug/m3</span><br>`;
      }
      return str;
    },
    dateTimeLabelFormats: {
      millisecond: "%H:%M:%S.%L",
      second: "%H:%M:%S",
      minute: "%H:%M",
      hour: "%H:%M",
      day: "%m-%d",
      week: "%m-%d",
      month: "%Y-%m",
      year: "%Y"
    }
  },
  legend: {
    enabled: true
  },
  plotOptions: {
    series: {
      connectNulls: true,
      lineWidth: 2,
      marker: {
        radius: 4
      }
      // cursor: "pointer"
    }
  },
  series: [
    { name: "", data: [] },
    { name: "", data: [] }
  ]
};

var moment_opts = {
  months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
    "_"
  ),
  monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
  longDateFormat: {
    LT: "Ah点mm分",
    LTS: "Ah点m分s秒",
    L: "YYYY-MM-DD",
    LL: "YYYY年MMMD日",
    LLL: "YYYY年MMMD日Ah点mm分",
    LLLL: "YYYY年MMMD日ddddAh点mm分",
    l: "YYYY-MM-DD",
    ll: "YYYY年MMMD日",
    lll: "YYYY年MMMD日Ah点mm分",
    llll: "YYYY年MMMD日ddddAh点mm分"
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function(hour, meridiem) {
    if (hour === 12) {
      hour = 0;
    }
    if (meridiem === "凌晨" || meridiem === "早上" || meridiem === "上午") {
      return hour;
    } else if (meridiem === "下午" || meridiem === "晚上") {
      return hour + 12;
    } else {
      // '中午'
      return hour >= 11 ? hour : hour + 12;
    }
  },
  meridiem: function(hour, minute, isLower) {
    var hm = hour * 100 + minute;
    if (hm < 600) {
      return "凌晨";
    } else if (hm < 900) {
      return "早上";
    } else if (hm < 1130) {
      return "上午";
    } else if (hm < 1230) {
      return "中午";
    } else if (hm < 1800) {
      return "下午";
    } else {
      return "晚上";
    }
  },
  calendar: {
    sameDay: function() {
      return this.minutes() === 0 ? "[今天]Ah[点整]" : "[今天]LT";
    },
    nextDay: function() {
      return this.minutes() === 0 ? "[明天]Ah[点整]" : "[明天]LT";
    },
    lastDay: function() {
      return this.minutes() === 0 ? "[昨天]Ah[点整]" : "[昨天]LT";
    },
    nextWeek: function() {
      var startOfWeek, prefix;
      startOfWeek = moment().startOf("week");
      prefix =
        this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? "[下]" : "[本]";
      return this.minutes() === 0 ? prefix + "dddAh点整" : prefix + "dddAh点mm";
    },
    lastWeek: function() {
      var startOfWeek, prefix;
      startOfWeek = moment().startOf("week");
      prefix = this.unix() < startOfWeek.unix() ? "[上]" : "[本]";
      return this.minutes() === 0 ? prefix + "dddAh点整" : prefix + "dddAh点mm";
    },
    sameElse: "LL"
  },
  ordinalParse: /\d{1,2}(日|月|周)/,
  ordinal: function(number, period) {
    switch (period) {
      case "d":
      case "D":
      case "DDD":
        return number + "日";
      case "M":
        return number + "月";
      case "w":
      case "W":
        return number + "周";
      default:
        return number;
    }
  },
  relativeTime: {
    future: "%s内",
    past: "%s前",
    s: "几秒",
    m: "1 分钟",
    mm: "%d 分钟",
    h: "1 小时",
    hh: "%d 小时",
    d: "1 天",
    dd: "%d 天",
    M: "1 个月",
    MM: "%d 个月",
    y: "1 年",
    yy: "%d 年"
  },
  week: {
    // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
};

moment.updateLocale("zh-cn", moment_opts);
export { option, optionDetail, group_map_tile };
